import styled, { css } from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import { asideBackground, contentBackground, horizontalPaddingSpaceOnMediumUp, horizontalPaddingSpaceOnSmallOnly } from ".";
export var Wrapper = styled.div.withConfig({
  componentId: "sc-1qc5dn5-0"
})(function (_ref) {
  var $hasAside = _ref.$hasAside;
  return $hasAside && css(["> *{&:first-child{border-bottom-right-radius:0;border-bottom-left-radius:0;}&:last-child{border-top-left-radius:0;border-top-right-radius:0;}}"]);
});
export var Container = styled.div.withConfig({
  componentId: "sc-1qc5dn5-1"
})(function (_ref2) {
  var $isAside = _ref2.$isAside,
    theme = _ref2.theme;
  return css(["padding:", " ", ";background:", ";", "{padding:", " ", ";border-radius:", ";box-shadow:", ";}", ""], space(3), space(horizontalPaddingSpaceOnSmallOnly), getColor(theme, contentBackground), breakpoint("medium"), space(5), space(horizontalPaddingSpaceOnMediumUp), getBorderRadius(theme, "large"), getBoxShadow(theme, "tiny"), !!$isAside && css(["background:", ";"], getColor(theme, asideBackground)));
});